import React, { useState, forwardRef, useImperativeHandle, useContext } from 'react';
import * as General from '../General/General.js';
import * as rsuite from 'rsuite'
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import * as BiIcon from 'react-icons/bi';
import { BasketContext } from "../Context/BasketContext.js";


const AddBasketItem = (Props, ref) => {


    const toaster = rsuite.useToaster();
    const { basketRef } = React.useContext(BasketContext);



    const AddItem = (Id, GetDataType) => {
        if (localStorage.getItem("CustomerFarmAsanId") == null || localStorage.getItem("CustomerFarmAsanId") == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("ابتدا وارد شوید با ثبت نام کنید.")), 'topCenter')
            window.location.href = "/UserLogin";


        }
        else {
            var RequestOptions = {
                data: {
                    "ProductId": Id.split("|")[0],
                    "Product": Id.split("|")[1],
                    "Count": Id.split("|")[2],
                    "StoreRoomInventoryId": Id.split("|")[3],
                    "Price": Id.split("|")[4],
                    "InsertType": Id.split("|")[5] == "2" || Id.split("|")[5] == 2 ? 1 : 0,
                    "DiscountPrice": 0,
                    "DiscountPercent": 0,
                    "CustomerId": localStorage.getItem("CustomerFarmAsanId"),
                    "Tax": 0,
                },
                url: General.ApiRoute() + "/Basket/Save",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {

                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage(Id.split("|")[1] + " با موفقیت به سبد خرید شما اضافه شد . ")), 'topCenter')
                            // updateBasketCount();
                            if (GetDataType == "Bind")
                                basketRef?.current?.Bind?.()
                            else
                                basketRef?.current?.Show?.();


                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                        }

                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                    })
            )

        }
    }

    const RemoveItem = (value, Count) => {
        var RequestOptions = {
            data: {
                "Id": value.split("|")[7],
                "ProductId": value.split("|")[0],
                "Product": value.split("|")[1],
                "Count": Count,
                "StoreRoomInventoryId": value.split("|")[3],
                "Price": value.split("|")[4],
                "InsertType": value.split("|")[5] == "2" || value.split("|")[5] == 2 ? 1 : 0,
                "DiscountPrice": 0,
                "DiscountPercent": 0,
                "CustomerId": localStorage.getItem("CustomerFarmAsanId"),
                "Tax": 0,
            },
            url: General.ApiRoute() + "/Basket/BasketItem_Delete",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage(value.split("|")[1] + " با موفقیت از سبد خرید شما حذف گردید . ")), 'topCenter')
                        basketRef?.current?.Bind();
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }



    React.useEffect(() => {
        console.log("basketRef from context:", basketRef);

    }, [])




    return (
        <>

            <rsuite.Button className={Props.className == "single" ? "" : "hide"} color="green" disabled={Props.disabled} onClick={() => AddItem(Props.value, "")} appearance="primary" block>  اضافه به سبد خرید </rsuite.Button>
            {/* <rsuite.Button className={Props.className == "Reservation" ? "" : "hide"} color="green" disabled={Props.disabled} onClick={() => AddItem(Props.value, "")} appearance="primary" block>  رزرو در سبد خرید </rsuite.Button> */}
            <div className={Props.className == "single" || Props.className == "Reservation" ? "hide" : "btn-group"} role="group" aria-label="Basic outlined example">
                <button class={Props.value.split("|")[6] != 1 ? "btn btn-link FarmAsan-text-red" : "hide"} onClick={() => RemoveItem(Props.value, Props.value.split("|")[6])}><BiIcon.BiTrash></BiIcon.BiTrash> حذف آیتم از سبد خرید</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                <button type="button" className="btn btn-outline-success rounded-1 me-4 ms-4 " onClick={() => AddItem(Props.value, "Bind")}><BiIcon.BiPlus></BiIcon.BiPlus></button>
                <button type="button" className='bg-white m-2 me-4 ms-4'>{Props.value.split("|")[6]}</button>
                <button type="button" className="btn btn-outline-danger rounded-1 me-4 ms-4 " onClick={() => RemoveItem(Props.value, 1)}>{Props.value.split("|")[6] != "1" ? <BiIcon.BiMinus></BiIcon.BiMinus> : <BiIcon.BiTrash></BiIcon.BiTrash>} </button>
            </div>
        </>
    )
}

export default AddBasketItem;